// Code review - In Progress
// Documentation - In Progress

import React, { useState } from "react";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { mappingroomtype } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import { useEffect } from "react";
import Loader from "../ReusableComponents/Loader";
import MapViewPopp from "../popup-containers/MapViewPopp";
import PopUpButtons from "../components/PopUpButtons";
import MappingRoomTypeWithAmenitiesPopp from "../popup-containers/MappingRoomTypeWithAmenitiesPopp";
import toast from "react-hot-toast";



const MappingRoomTypeWithAmenities = () => {

    // UI use state management
    const [isLoading, setIsLoading] = useState(false);
    const [popUpOpen, setpopUpOpen] = useState(false);
    const [popUpOpen1, setpopUpOpen1] = useState(false);
    const [roomType, setRoomType] = useState('');
    const [roomTypeName, setRoomTypeName] = useState('');
    const [amenitiesDatas, setAmenitiesDatas] = useState([]);
    const [mapRoomTypeAndAmenitiesDatas, setMapRoomTypeAndAmenitiesDatas] = useState([]);
    const mstClientId = sessionStorage.getItem("MstClientId");


    // Grid data
    const [bindRoomTypeDatas, setBindRoomTypeDatas] = useState([]);
    const [bindAmenitiesDatas, setBindAmenitiesDatas] = useState([]);
    const [bindMapRoomTypeAndAmenitiesDatas, setBindMapRoomTypeAndAmenitiesDatas] = useState([]);

    useEffect(() => {

        getRoomTypeTableDatas();
        getAmenitiesTableDatas();
        getMapRoomTypeAndAmenitiesDatas();
    }, []);


    useEffect(() => {
        if (!popUpOpen) {
            cancel()
        }

    }, [popUpOpen]);


    // Getting Room Type values
    const getRoomTypeTableDatas = async () => {
        const data = {
            mstClientId: mstClientId,
        };
        setIsLoading(true); 
        const response = await BindPostAPI(data,"RoomTypeAPI/BindRoomType");
        setBindRoomTypeDatas(response.data.Table);
        setIsLoading(false); 
    };




    // Getting Space values
    const getAmenitiesTableDatas = async () => {
         
        const data = {
            mstClientId: mstClientId,
        };
        setIsLoading(true); 
        const response = await BindPostAPI(data,"AmenitiesAPI/BindAmenities");
        setBindAmenitiesDatas(response.data.Table);
        setIsLoading(false); 
    };

    // Getting Space values
    const getMapRoomTypeAndAmenitiesDatas = async () => {
         
        const data = {
            mstClientId: mstClientId,
        };
        setIsLoading(true); 
        const response = await BindPostAPI(data, "MappingAPI/BindMapRoomTypeAndAmenities");
        setBindMapRoomTypeAndAmenitiesDatas(response.data.Table);
        setIsLoading(false); 
    };
    const handlePopup = (rowIndex, flag) => {
         
        setpopUpOpen(true)


        var RoomtypeId = (bindRoomTypeDatas[rowIndex].MstRoomTypeId);
        console.log(RoomtypeId);

        setRoomType(RoomtypeId)
        setAmenitiesDatas(bindAmenitiesDatas)
        const filteredMapData = bindMapRoomTypeAndAmenitiesDatas.filter(
            item => item.MstRoomTypeId === RoomtypeId
        );

        setMapRoomTypeAndAmenitiesDatas(filteredMapData)
    };

    const handlePopup1 = (rowIndex, flag) => {
         


        var RoomtypeId = (bindRoomTypeDatas[rowIndex].MstRoomTypeId);
        var Roomtype = (bindRoomTypeDatas[rowIndex].RoomType);
        console.log(RoomtypeId);

        setRoomType(RoomtypeId)

        setRoomTypeName(Roomtype)

        const filteredMapData = bindMapRoomTypeAndAmenitiesDatas.filter(
            item => item.MstRoomTypeId === RoomtypeId
        );
        if (filteredMapData.length != 0) {
            setpopUpOpen1(true)
            setMapRoomTypeAndAmenitiesDatas(filteredMapData)
        } else {

            toast.error(
                `No data available. 👎`,
                {
                    duration: 3000,
                    position: "top-center",
                }
            );
        }


    };

    const cancel = () => {
        setpopUpOpen1(false)
        setRoomType('')
        setRoomTypeName('')
        setMapRoomTypeAndAmenitiesDatas([])
        getRoomTypeTableDatas();
        getAmenitiesTableDatas();
        getMapRoomTypeAndAmenitiesDatas();
    };
    return (
        <MainLayout pageName={"2"}>
            <Loader
                isVisible={isLoading}
                size="h-20 w-20"
                color="border-t-black"
                blur={true}
            />
            <GridPage
                title="Map Room Type and Amenities"
                header={mappingroomtype}
                records={bindRoomTypeDatas}
                blockView={true}
                addView={true}
                onMap={handlePopup}
                onMapView={handlePopup1}
            />


            <MainPopup
                popUpOpen={popUpOpen}
                setpopUpOpen={setpopUpOpen}
                Open={handlePopup}
            >
                <div>
                    <PopUpScreenTitle
                        title="Map Room Type and Amenities"
                        setpopUpOpen={setpopUpOpen}
                        hederDetails={true}
                    />

                    <MappingRoomTypeWithAmenitiesPopp
                        data1={roomType}
                        amenitiesData={amenitiesDatas}
                        isOpen={setpopUpOpen}
                        data2={mapRoomTypeAndAmenitiesDatas}
                    />
                </div>


            </MainPopup>

            <MainPopup
                popUpOpen={popUpOpen1}
                setpopUpOpen={setpopUpOpen1}
                Open={handlePopup1}
            >
                <div>
                    <PopUpScreenTitle
                        title="Map Room Type and Amenities"
                        setpopUpOpen={setpopUpOpen1}
                        viewDetails={true}
                    />

                    <MapViewPopp
                        data={1}
                        data1={roomTypeName}
                        data2={mapRoomTypeAndAmenitiesDatas} />
                    <PopUpButtons
                        viewDetails={true}
                        cancel={cancel}
                    />
                </div>

            </MainPopup>
        </MainLayout>
    );
};
export default MappingRoomTypeWithAmenities;
